import {fragments} from '@/gql';
import gql from 'graphql-tag';
export default gql`
  query CallsheetAnalysis($id: ID!) {
    CallsheetAnalysis(id: $id) {
      ...callsheetAnalysisDetail
    }
  }
  ${fragments.callsheetAnalysisProgressDetail}
  ${fragments.callsheetAnalysisDetail}
  ${fragments.kgraphDetail}
  ${fragments.filmDetail}
  ${fragments.personDetail}
  ${fragments.companyDetail}
  ${fragments.companyNames}
  ${fragments.companyNameDetail}
  ${fragments.contactDetail}
  ${fragments.profession}
  ${fragments.callsheetDetail}
  ${fragments.artworkDetails}
  ${fragments.companyDepartmentDetail}
  ${fragments.companyTypeTree}
  ${fragments.companyType}
  ${fragments.personArtworks}
  ${fragments.artworkToArtifacts}
  ${fragments.artworkDetails}
  ${fragments.artworkArtifact}
`;
